<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      size="small"
      :loading="loading"
      resizable
      border
      :expand-config="{ reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('table_label_goods_info') || '订单产品'
            }}</span>
            <el-divider
              v-if="!disabled || !auditDisabled"
              direction="vertical"
            ></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              v-if="!disabled || !auditDisabled"
              variant="outline-success"
              @click="openChooseGoods()"
              >{{ $l('table_label_add_goods') || '添加产品' }}
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="batchDel()"
              v-if="!disabled"
            >
              <i class="el-icon-delete" />
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            v-if="
              !disabled ||
                (!auditDisabled && !row.orderTechPricingOrderGoodsCode)
            "
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:spec="{ row }">
        <span>{{ row.spec || '' }}</span>
        <span>{{ row.specUnit || '' }}</span>
      </template>
    </vxe-grid>
    <choose-order-goods-dialog
      :visible.sync="orderGoodsDialogVisible"
      :title="
        $l('INDEX.order_goods_label_orderGoods_information') || '订单产品信息'
      "
      :orderCode="orderCode"
      :orderTechPricingCode="orderTechPricingCode"
      :orderTechPricingSpecCode="orderTechPricingSpecCode"
      @confirm="orderGoodsConfirm"
      type="checkbox"
    />
  </div>
</template>
<script>
import ChooseOrderGoodsDialog from './choose-order-goods/dialog.vue'
import { cloneDeep } from 'lodash'
export default {
  mixins: [],
  components: { ChooseOrderGoodsDialog },
  props: {
    orderCode: { type: String, default: '' },
    orderTechPricingCode: { type: String, default: '' },
    orderTechPricingSpecCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    auditDisabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    goodsList: { type: Array, default: () => [] },
  },
  watch: {
    goodsList: {
      handler() {
        this.tableData = cloneDeep(this.goodsList || [])
      },
      immediate: true,
    },
  },
  data() {
    return {
      tableHeight: 350,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          type: 'checkbox',
          visible: !this.disabled,
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 60,
          visible: !this.disabled || !this.auditDisabled,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('table_label_goods_masterNcNo') || '成品编码',
          field: 'masterNcNo',
          minWidth: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_goods_ncNo') || '子件编码',
          field: 'ncNo',
          minWidth: 200,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_goods_goodsName') || '产品名称',
          field: 'goodsName',
          minWidth: 250,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_goods_goodsColor') || '颜色',
          field: 'goodsColor',
          minWidth: 150,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_goods_spec') || '规格',
          field: 'spec',
          minWidth: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          slots: { default: 'spec' },
          showOverflow: true,
        },
      ],
      tableData: [],
      orderGoodsDialogVisible: false,
    }
  },
  methods: {
    getTableData() {
      return this.tableData
    },
    openChooseGoods() {
      this.orderGoodsDialogVisible = true
    },
    orderGoodsConfirm(data) {
      if (!data || !data.length) return
      const tableData = data.filter(
        (i) =>
          this.tableData.findIndex(
            (j) => j.noticeOrderGoodsSpecCode === i.noticeOrderGoodsSpecCode
          ) < 0
      )
      this.tableData.push(...tableData)
    },
    // 批量删除
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) return

      this.$confirm(
        this.$l('tips_delete_data') || '您确定要删除所勾选数据吗?'
      ).then((type) => {
        if (type === 'confirm') {
          this.$refs.vxeGrid.removeCheckboxRow()
          const deleteCodes = new Set(
            data.map((d) => d.noticeOrderGoodsSpecCode)
          )
          this.tableData = this.tableData.filter(
            (row) => !deleteCodes.has(row.noticeOrderGoodsSpecCode)
          )
        }
      })
    },
    //单行删除
    del(row) {
      let index = this.$refs.vxeGrid.getRowIndex(row)
      this.tableData.splice(index, 1)
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
  },
}
</script>
